import boasVindas from '@/assets/images/prof/PROF-BOAS-VINDAS.png';
import pensando from '@/assets/images/prof/PROF-PENSANDO.png';
import joinha from '@/assets/images/prof/PROF-JOINHA.png';
import atividades from '@/assets/images/prof/PROF-ATIVIDADES.png';

// Poses do personagem do professor.
//
// PROF-BOAS-VINDAS foi gerada com gpt-image-1 usando a chave
// IMAGE_PROMPT_TOKEN (secret production/est-prep-educa7-api), tendo as poses
// da T.I.A. como referência de estilo. Saiu 661x700, dentro da spec abaixo.
//
// Spec da arte (medida nas poses da T.I.A., que o TiaBanner já consome):
//   - PNG com alpha, SEM fundo (as poses da tia são `alpha=Blend`)
//   - conteúdo colado na base do canvas — o banner usa
//     `position:absolute; bottom:0; object-contain object-bottom`,
//     então qualquer folga embaixo faz o personagem flutuar.
//     Medido: folga_abaixo = 0px em TIA-BOAS-VINDAS, ATIVIDADES e CURSOS.
//   - preferir canvas trimado (canvas == conteúdo), como
//     TIA-ATIVIDADES (677x700) e TIA-CURSOS (635x700). A TIA-BOAS-VINDAS é
//     1024x1024 com 63px de margem morta no topo, o que encolhe o
//     personagem à toa dentro do `object-contain`.
//
// REGRA DA RAZÃO CORPO/CABEÇA — não gere pose nova sem ler isto.
//
// O TiaBanner escala por ALTURA (`imageHeight={215}`) e ancora pela BASE
// (`object-contain object-bottom`, `bottom:0`). Consequência: a razão
// corpo/cabeça do PNG decide DUAS coisas de uma vez — o tamanho que a cabeça
// aparece na tela E a altura em que ela fica. Duas poses com razões
// diferentes fazem o personagem dar zoom e pular de altura ao trocar de tela.
//
// Então toda pose tem que fechar na razão da BOAS-VINDAS (3.02), e não numa
// altura de canvas fixa. Normalizar tudo pra 700px de altura NÃO resolve —
// foi o erro que custou meia manhã.
//
// A razão só dá pra DIMINUIR, cortando na base (cortar no topo decapita).
// Por isso o prompt tem que pedir enquadramento ABERTO e sobrar corpo:
//   ✅ "wide full-body shot from the knees up, standing small and centered,
//       surrounded by generous empty space"
//   ❌ "framed from the waist up"  ← sai em ~2.4 e não tem como consertar
//
// Medido com /tmp/prof-poses/headmeasure.py (maior componente conexo do
// alpha, então objeto flutuante não contamina a medida):
//
//   pose           canvas    cabeça   razão   cabeça @215px
//   BOAS-VINDAS    661x700    232     3.02      71.2px  ← referência
//   PENSANDO       444x700    232     3.01      71.4px
//   JOINHA         473x700    232     3.00      71.7px
//   ATIVIDADES     784x700    231     3.01      71.4px
//
export const BOAS_VINDAS = boasVindas;
export const PENSANDO = pensando;
export const JOINHA = joinha;
export const ATIVIDADES = atividades;

// Todas as poses disponíveis, pra quem precisar iterar/pré-carregar.
export const PROF_POSES = { BOAS_VINDAS, PENSANDO, JOINHA, ATIVIDADES };
